module.exports = __webpack_public_path__ + "static/img/kefu_code2.a1225174.png";